<template>
<w-sliding-popup class="topology-image-setting-popup" popupClass="settings" modalClass="is-fullscreen" ref="slidingPopup" title="이미지 설정" @close="onClose" @open="onOpen" type="full">
<div class="main" slot="content" style="width: 100%">
  <div>
    <div class="content-wrapper">
      <w-image-settings-view v-if="visible"></w-image-settings-view>
    </div>
  </div>
</div>
</w-sliding-popup>
</template>

<script>
import MapConst from '@/constants/topologymap';

import WImageSettingsView from '@/views/settings/operation/ImageSettings/ImageSettingsView';

export default {
  name: 'WImageSettingPopup',
  components: {
    WImageSettingsView,
  },
  data() {
    return {
      /**
       * 이미지 설정 컴포넌트 생성/제거 Flag
       * 팝업창이 열릴때마다 화면을 초기화시키기 위해 사용된다.
       * @type {Boolean}
       */
      visible: false,
    };
  },
  methods: {
    /**
     * 팝업 오픈 요청
     * @author KangBonghun(toto1323)
     * @param  {[type]} params [description]
     */
    open() {
      this.$refs.slidingPopup.open();
    },
    /**
     * 팝업 닫기 요청
     * @author KangBonghun(toto1323)
     */
    close() {
      this.$refs.slidingPopup.close();
    },
    onOpen() {
      this.$nextTick(() => {
        this.visible = true;
      });
    },
    onClose() {
      this.$nextTick(() => {
        this.visible = false;
      });

      this.$mapEventBus.$emit(MapConst.MAP_EVENTBUS.IMAGE_LOAD);
    },
  },
};
</script>
<style>
.topology-image-setting-popup .main-content-wrapper{
  /* padding-top: 0px !important; */
  padding: 0px !important;
}
.topology-image-setting-popup .el-icon-search{
  font-size: 12px !important;
}
.topology-image-setting-popup .el-dialog__headerbtn{
  top: 2px !important;
}
</style>
<style module>
</style>



// WEBPACK FOOTER //
// src/views/topologymap/components/popup/ImageSettingPopup.vue